var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhonPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 28,
    viewBox: "0 0 27 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 12.875V9.5H14.625V7.25H18V3.875H20.25V7.25H23.625V9.5H20.25V12.875H18ZM22.4438 24.125C20.1 24.125 17.7844 23.6143 15.4969 22.5928C13.2094 21.5713 11.1281 20.1226 9.25313 18.2469C7.37813 16.3711 5.92987 14.2899 4.90837 12.0031C3.88687 9.71638 3.37575 7.40075 3.375 5.05625C3.375 4.71875 3.4875 4.4375 3.7125 4.2125C3.9375 3.9875 4.21875 3.875 4.55625 3.875H9.1125C9.375 3.875 9.60938 3.96425 9.81563 4.14275C10.0219 4.32125 10.1438 4.532 10.1813 4.775L10.9125 8.7125C10.95 9.0125 10.9406 9.26562 10.8844 9.47187C10.8281 9.67812 10.725 9.85625 10.575 10.0062L7.84687 12.7625C8.22187 13.4562 8.667 14.1264 9.18225 14.7729C9.6975 15.4194 10.2649 16.043 10.8844 16.6438C11.4656 17.225 12.075 17.7642 12.7125 18.2615C13.35 18.7587 14.025 19.2133 14.7375 19.625L17.3812 16.9812C17.55 16.8125 17.7705 16.6861 18.0428 16.6021C18.315 16.5181 18.582 16.4945 18.8438 16.5312L22.725 17.3187C22.9875 17.3938 23.2031 17.5299 23.3719 17.7271C23.5406 17.9244 23.625 18.1445 23.625 18.3875V22.9438C23.625 23.2812 23.5125 23.5625 23.2875 23.7875C23.0625 24.0125 22.7812 24.125 22.4438 24.125Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhonPlus);
export default __webpack_public_path__ + "static/media/phon-plus.05b98746587a27e179abacf0608bf196.svg";
export { ForwardRef as ReactComponent };